import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

import { FamilyCodeResponse } from '../interfaces/family-code.interface';

@Injectable({
  providedIn: 'root',
})
export class FamilyCodeTransmissionService extends ApiService {
  public getFamilyDetails(reqData: any): Observable<FamilyCodeResponse> {
    return this.get<FamilyCodeResponse>(
      this.replacePathInfo(ROUTES.FC, {
        fcode: reqData,
      })
    );
  }
  public fetchDetailsForMerge(reqData: any): Observable<FamilyCodeResponse> {
    return this.get<FamilyCodeResponse>(
      this.replacePathInfo(ROUTES.FC_FOR_MERGE, {
        fcode: reqData,
      })
    );
  }
  public getFamilySignInDetails(reqData: any): Observable<FamilyCodeResponse> {
    return this.get<FamilyCodeResponse>(
      this.replacePathInfo(ROUTES.FC_SIGNIN, {
        fcode: reqData,
      })
    );
  }

  public verifyFamilyDetails(reqData: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.VERIFY_FC, {
        memberKey: reqData,
      })
    );
  }
}
